import { tratamientoRelacion } from "@/models/tratamientoRelacion";

const stateData = () => ({
    filtros: {
        modelo_producto_id: null,
        tipo_luna_id: null,
    },
    addRelacion: {
        show: false,
        relacion: null,
    },
    editRelacion: {
        show: false,
        relacion: null,
    },
    deleteRelacion: {
        show: false,
        relacion: null,
    },
})

const mutations = {
    SET_FILTROS(state, payload) {
        state.filtros = { ...state.filtros, ...payload };
    },
    MODAL_ADD_RELACION(state, { code_parent, posicion }) {
        const code = Math.random().toString(36).substring(2, 10).toUpperCase();

        state.addRelacion.relacion = {
            ...tratamientoRelacion,
            idmodelo_producto: state.filtros.modelo_producto_id,
            idtipo_luna: state.filtros.tipo_luna_id,
            code: code,
            code_parent: code_parent,
            posicion: posicion,
        };

        state.addRelacion.show = true;
    },
    MODAL_EDIT_RELACION(state, payload) {
        state.editRelacion.relacion = payload;
        state.editRelacion.show = true;
    },
    MODAL_DELETE_RELACION(state, payload) {
        state.deleteRelacion.relacion = payload;
        state.deleteRelacion.show = true;
    },
    MODAL_RESET(state,modalName) {
        const modales = stateData();

        if ( !modales.hasOwnProperty(modalName) ) {
            console.warn(`El modal ${modalName} no existe.`);
            return;
        }

        state[modalName] = modales[modalName];
    }
}


const actions = {
    setFiltros({ commit }, payload) {
        commit('SET_FILTROS', payload);
    },
    addRelacion({ commit }, payload) {
        commit('MODAL_ADD_RELACION', payload);
    },
    editRelacion({ commit }, payload) {
        commit('MODAL_EDIT_RELACION', payload);
    },
    deleteRelacion({ commit }, payload) {
        commit('MODAL_DELETE_RELACION', payload);
    },

    reorderRelaciones({ commit }, payload) {
        // Aquí podrías agregar lógica adicional si es necesario
        commit('TRIGGER_REORDER', payload);
    },

    resetModal({ commit }, modalName) {
        commit('MODAL_RESET', modalName);
    }
}

export default {
  namespaced: true,
  state: stateData(),
  mutations,
  actions,
}
